import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import Spinner from "../Spinner/Spinner";
import ReCAPTCHA from "react-google-recaptcha";
import "./CommentModal.scss";
import "./Responsive.scss";

const CommentModal = (props) => {
  const [commentText, setCommentText] = useState("");
  const [recaptcha, setRecaptcha] = useState("");

  useEffect(() => {
    return () => {
      setCommentText("");
      setRecaptcha("");
    };
  }, []);

  const commentTextHandler = (e) => {
    setCommentText(e.target.value);
  };

  const recaptchaHandler = (recaptchaValue) => {
    setRecaptcha(recaptchaValue);
  };

  const expireRecaptcha = () => {
    setRecaptcha("");
  };

  return (
    <React.Fragment>
      <div className={props.show ? "commentModal show" : "commentModal"}>
        <div className="commentForm">
          <div className="header">
            <p>ارسال دیدگاه</p>
            <FaTimes onClick={(e) => props.hideCommentModal(e)} />
          </div>
          <div className="formGroup">
            <textarea
              className="commentText"
              value={commentText}
              onChange={(text) => commentTextHandler(text)}
              placeholder="متن دیدگاه"
            ></textarea>
          </div>
          <div className="formGroup">
            <div className="recaptcha">
              <ReCAPTCHA
                sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt"
                onChange={recaptchaHandler}
                onExpired={expireRecaptcha}
              />
              {/* <ReCAPTCHA sitekey="6Lfgov0bAAAAAFGd8c6ALNbuFDyrElRKdUukingY" onChange={recaptchaHandler} onExpired={expireRecaptcha} /> */}
            </div>
          </div>
          <div className="formGroup">
            <button className="commentSubmit" onClick={() => props.submitHandler(commentText, recaptcha)}>
              {props.showSpinner ? <Spinner color="#fff" /> : "ارسال دیدگاه"}
            </button>
          </div>
          <div className="formGroup">
            <p className="commentError">{props.message}</p>
          </div>
        </div>
      </div>
      <div
        className="backdropComment"
        style={{ display: props.show ? "block" : "none" }}
        onClick={(e) => props.hideCommentModal(e)}
      ></div>
    </React.Fragment>
  );
};

export default React.memo(CommentModal);
